import type { TotpRepository } from "../../domain/repositories/TotpRepository";
import type { SessionPort } from "../../domain/ports/SessionPort";
import { getBearerTokenForEmailOtp } from "../../infrastructure/session/getBearerTokenForEmailOtp";

export const sendEmailOtp = async (
  repo: TotpRepository,
  sessionPort: SessionPort,
  email: string,
  purpose: string,
  bearerTokenOverride?: string,
): Promise<number> => {
  const bearerToken =
    bearerTokenOverride ?? getBearerTokenForEmailOtp(purpose, sessionPort);

  if (purpose === "LOGIN" && !bearerToken) {
    throw new Error(
      "Temporary access token required to send login OTP. Complete login with email and password first.",
    );
  }

  return repo.sendEmailTotp(email, purpose, bearerToken);
};